import React from 'react'
import Text from 'components/Text'
import Button from 'components/Button'

/**
 * @param props
 * @param props.text
 * @param props.onClick
 * @param props.url
 * @param props.color
 * @param props.children
 * @return {Element}
 * @constructor
 */
export default function ProfileBottomButton (props) {
  const {
    text,
    onClick,
    url,
    color,
    children
  } = props

  return (
    <Button
      onClick={onClick}
      isFullWidth
      url={url}
      color={color}
      style={{
        justifyContent: 'flex-start',
        display: 'flex',
        alignItems: 'center'
      }}
      linkStyles={{ justifyContent: 'unset' }}
    >
      <Text
        c='#151D21'
        fs='0.875em'
        fw='700'
      >
        {text}
      </Text>
      {children}
    </Button>
  )
}
